import dayjs from "dayjs";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Button, Input, Layer } from "../../components";
import { AppContext, SET_IDCARD_STATE } from "../../components/AppProvider";
import DefaultContainer from "../../components/UI/Container/DefaultContainer";
import HeaderNavigate from "../../components/UI/Header/HeaderNavigate";
import LabelButton from "../../components/UI/Label/LabelButton";
import { PostApi1977, PostApi1978 } from "../../modules/network/padoPost";
import { checkData, checkNum10 } from "../../modules/utils/CheckLogic";
import { encodeFileToBase64 } from "../../modules/utils/encodeFileToBase64/encodeFileToBase64";
import { NativeAction } from "../../modules/utils/HandleWs";
import { IC } from "../../resources/Assets";
import { maxLengthCheck } from "../common/maxLengthCheck/maxLengthCheck";
import CommonNoticeText from "../common/NoticeText/CommonNoticeText";
import {
  getIdCard,
  openIdCard,
  setIdCard,
} from "../Nftf/Interface/NFTF/NativeApi";

const Management = props => {
  const {
    setPageType,
    pageType,
    familyData,
    familyList,
    setToastView,
    idCardState2,
    dispatch2,
  } = props;
  const { userinfo, phonecfg, cfg, idCardState, dispatch } =
    useContext(AppContext);

  const [idCardData, setIdCardData] = useState();
  const [fileChange, setFileChange] = useState(false);

  const [famzSeqNo, setFamzSeqNo] = useState(
    pageType === "add" ? "" : familyData.famzSeqNo
  );

  const [name, setName] = useState(pageType === "add" ? "" : familyData.famzNm);
  const [number, setNumber] = useState(
    pageType === "add" ? userinfo.userPhone : familyData.famzTelNo
  );
  const [birth, setBirth] = useState(
    pageType === "add" ? "" : familyData.famzBirthDt
  );
  const [gender, setGender] = useState(
    pageType === "add" ? "" : familyData.famzGndr
  );

  const [viewMsgLayer, setViewMsgLayer] = useState(false);
  const [msgState, setMsgState] = useState("check");
  const messageLayerData = {
    check: {
      headerIcon: "",
      title: "프로필을 삭제하시겠어요?",
      desc: ["프로필 삭제시 입력하신 정보가 모두 사라집니다"],
      ps: "",
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "아니오",
        },
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            updateFamily("D");
          },
          text: "네",
        },
      ],
    },
    failed: {
      headerIcon: "",
      title: "잘못된 비밀번호 입니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 입력해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "확인",
        },
      ],
    },
    backCheck: {
      headerIcon: "",
      title: "이전 페이지로 이동하시겠어요?",
      desc: ["현재 페이지의 신분증 정보는 저장되지 않습니다"],
      ps: "",
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "아니오",
        },
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setIdCardData({ file: "", fileName: "" });
            setPageType("list");
          },
          text: "네",
        },
      ],
    },
    backDataCheck: {
      headerIcon: "",
      title: "이전 페이지로 이동하시겠어요?",
      desc: ["변경한 정보는 저장되지 않습니다"],
      ps: "",
      button: [
        {
          severity: "light",
          disable: "off",
          small: false,
          clickEvent: () => setViewMsgLayer(false),
          text: "아니오",
        },
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setPageType("list");
          },
          text: "네",
        },
      ],
    },
    dup: {
      headerIcon: "",
      title: "중복된 이름은 사용이 불가능합니다",
      desc: ["이름을 확인하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "네",
        },
      ],
    },
    empty: {
      headerIcon: "",
      title: "프로필 저장에 실패했습니다",
      desc: ["입력 정보를 확인하세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errName: {
      headerIcon: "",
      title: "이름을 입력해주세요",
      desc: ["이름을 입력하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errCheckName: {
      headerIcon: "",
      title: "이름 형식에 문제가 있습니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errPhone: {
      headerIcon: "",
      title: "전화번호를 입력해주세요",
      desc: ["전화번호를 입력하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errCheckPhone: {
      headerIcon: "",
      title: "전화번호 형식에 문제가 있습니다",
      desc: ["입력하신 내용을 확인하시고", <br />, "다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errBirth: {
      headerIcon: "",
      title: "생년월일 정보를 입력해주세요",
      desc: ["생년월일 정보를 입력하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errBirthCheck: {
      headerIcon: "",
      title: "생년월일 정보에 문제가 있습니다",
      desc: ["생년월일 정보를 확인하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errGender: {
      headerIcon: "",
      title: "성별 정보를 입력해주세요",
      desc: ["성별 정보를 입력하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
    errIdCard: {
      headerIcon: "",
      title: "신분증 이미지를 등록해주세요",
      desc: ["신분증 이미지를 등록하시고 다시 시도해주세요"],
      ps: "",
      button: [
        {
          severity: "primary",
          disable: "off",
          small: false,
          clickEvent: () => {
            setViewMsgLayer(false);
          },
          text: "확인",
        },
      ],
    },
  };

  const checkVersion = () => {
    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 83) {
        return "notActive";
      } else {
        return "fileData";
      }
    } else {
      if (parseInt(phonecfg.version.split(".")[2]) > 37) {
        return "notActive";
      } else {
        return "fileData";
      }
    }
  };

  const rtnEvent = (value, status) => {
    if (value != "-1") {
      if (status === "1") {
        setIdCardData({
          file: decodeURIComponent(value),
          fileName:
            pageType === "add"
              ? name.trim() + dateTime() + ".jpg"
              : familyData.famzFileNm + ".jpg",
        });
        // setFileChange(true);
      } else {
        setIdCardData({
          file: decodeURIComponent(value),
          fileName:
            pageType === "add"
              ? name.trim() + dateTime() + ".jpg"
              : familyData.famzFileNm + ".jpg",
        });
        // setFileChange(true);
      }
    }
  };

  const addFamily = () => {
    if (checkInputData() && checkDuplicate()) {
      PostApi1977(
        userinfo,
        cfg,
        phonecfg,
        name.trim(),
        birth.trim(),
        gender,
        number.trim(),
        name.trim() + dateTime()
      )
        .then(res => {
          if (res.rsltCd === "E000") {
            setIdCard(idCardData.file, name.trim() + dateTime());
            setToastView({
              view: true,
              msgType: "famzAdd",
            });
            setPageType("list");
          } else {
            alert("등록실패");
          }
        })
        .catch(err => {
          console.log("ERR (addFamily):: ", err);
        });
    } else {
      setViewMsgLayer(true);
    }
  };

  const updateFamily = procType => {
    if (procType === "D" || (checkInputData() && checkDuplicate())) {
      PostApi1978(
        userinfo,
        cfg,
        phonecfg,
        procType,
        famzSeqNo,
        name.trim(),
        birth.trim(),
        gender,
        number.trim(),
        familyData.famzFileNm
      )
        .then(res => {
          if (res.rsltCd === "E000") {
            if (procType === "D") {
              setPageType("list");
              setToastView({
                view: true,
                msgType: "famzDelete",
              });
            } else {
              setIdCard(idCardData.file, familyData.famzFileNm);
              setPageType("list");
            }
          } else {
            alert("등록실패");
          }
        })
        .catch(err => {
          console.log("ERR (updateFamily):: ", err);
        });
    } else {
      setViewMsgLayer(true);
    }
  };

  const checkDuplicate = () => {
    // 가족 등록
    if (famzSeqNo == "") {
      if (familyList.find(item => item.famzNm === name)) {
        setMsgState("dup");
        return false;
      } else {
        return true;
      }
    } else {
      if (
        familyList
          .filter(e => e.famzNm === name)
          .find(item => item.famzSeqNo != famzSeqNo)
      ) {
        setMsgState("dup");
        return false;
      } else {
        return true;
      }
    }
  };

  // 입력 값 체크
  const checkInputData = () => {
    if (!name || name == "" || name.trim().length < 2) {
      setMsgState("errName");
    } else if (checkData("name", name.trim()) == false) {
      setMsgState("errCheckName");
    } else if (!number || number == "") {
      setMsgState("errPhone");
    } else if (checkData("number", number.trim()) == false) {
      setMsgState("errCheckPhone");
    } else if (!birth || birth == "" || birth.trim().length < 8) {
      // 유효한 날짜인지 체크
      // 오늘 기준 120년미만 입력 불가
      setMsgState("errBirth");
    } else if (!checkBirth()) {
      setMsgState("errBirthCheck");
    } else if (!gender || gender == "") {
      setMsgState("errGender");
    } else if (!idCardData || idCardData.file == "") {
      setMsgState("errIdCard");
    } else {
      if (
        name &&
        number &&
        birth &&
        gender &&
        idCardData &&
        idCardData.file != ""
      ) {
        if (checkData("number", number.trim()) == false) {
          setMsgState("errCheckPhone");
        } else if (checkData("name", name.trim()) == false) {
          setMsgState("errCheckName");
        } else {
          return true;
        }
      } else {
        setMsgState("empty");
      }
    }

    return false;
  };

  const checkBirth = () => {
    if (!birth || birth == "" || birth.trim().length < 8) {
      return false;
    } else if (
      dayjs(birth).format("YYYYMMDD") > dayjs().format("YYYYMMDD") ||
      dayjs(birth).format("YYYYMMDD") <
        dayjs(
          (
            parseInt(dayjs().format("YYYYMMDD").substring(0, 4)) - 120
          ).toString() + dayjs().format("YYYYMMDD").substring(4, 8)
        ).format("YYYYMMDD")
    ) {
      return false;
    } else if (
      parseInt(birth.substring(4, 6)) > 12 ||
      parseInt(birth.substring(4, 6)) < 1
    ) {
      return false;
    } else if (
      parseInt(birth.substring(6, 8)) > 31 ||
      parseInt(birth.substring(6, 8)) < 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  // 변경된 데이터 체크
  const changeDataCheck = () => {
    if (
      name.trim() != familyData.famzNm ||
      number.trim() != familyData.famzTelNo ||
      birth.trim() != familyData.famzBirthDt ||
      gender != familyData.famzGndr
    ) {
      return false;
    } else {
      return true;
    }
  };

  const checkEmptyData = () => {
    if (name.trim() != "" || birth.trim() != "" || gender != "") {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#FFFFFF");
  }, [phonecfg.version]);

  useEffect(() => {
    // 진료 신청한 환자의 이름
    if (pageType === "mod") {
      if (getIdCard(familyData.famzFileNm) === "-1") {
        setIdCardData({ file: "", fileName: "" });
      }
    } else {
      setIdCardData({ file: "", fileName: "" });
    }
  }, []);

  useEffect(() => {
    if (idCardState.reload) {
      rtnEvent(idCardState.data.value1, idCardState.data.value2);
      dispatch({
        type: SET_IDCARD_STATE,
        data: { type: "reload" },
      });
    }
  }, [idCardState.reload]);

  const dateTime = () => {
    let now = new Date();
    //연도 구하기
    let nowYear = now.getFullYear();
    //달 구하기
    let nowMonth = now.getMonth() + 1;
    //일 구하기
    let nowDate = now.getDate();
    //현재 시 구하기
    let nowHours = now.getHours();
    //현재 분 구하기
    let nowMins = now.getMinutes();
    //현재 초 구하기
    let nowSec = now.getSeconds();

    //그래서 지금은...
    let today =
      nowYear.toString() +
      checkNum10(nowMonth).toString() +
      checkNum10(nowDate).toString() +
      checkNum10(nowHours).toString() +
      checkNum10(nowMins).toString() +
      checkNum10(nowSec).toString();
    return today;
  };

  return (
    <Fragment>
      <DefaultContainer>
        <HeaderNavigate
          leftIcon={{
            imgSrc: IC.etc.ICON_CHEVRON_LEFT,
            action: () => {
              if (pageType === "mod" && (!changeDataCheck() || fileChange)) {
                if (changeDataCheck()) {
                  setMsgState("backCheck");
                } else {
                  setMsgState("backDataCheck");
                }

                setViewMsgLayer(true);
              } else {
                // 입력값 체크
                if (pageType != "mod" && (!checkEmptyData() || fileChange)) {
                  setMsgState("backDataCheck");
                  setViewMsgLayer(true);
                } else {
                  setPageType("list");
                }
              }
            },
          }}
          headerTitle={pageType === "add" ? "가족 정보 추가" : "가족 정보 수정"}
        />

        <ContentsBody>
          <ContentBody style={{ flex: "1 0 auto" }}>
            <Input
              // state={"error"}
              state={"default"}
              title_view={true}
              title="이름"
              input_view={true}
              input_type="text"
              input_pattern=""
              input_disable={false}
              input_placeholder="이름을 입력해주세요"
              input_defaultValue={name.replace(/^\s*/, "")}
              input_onChange={e => {
                maxLengthCheck(20, e);

                setName(e.target.value);
              }}
              button_view={false}
            />
            <Input
              state={"default"}
              title_view={true}
              title="전화번호"
              input_view={true}
              input_type="number"
              input_pattern="\d*"
              input_disable={false}
              input_placeholder="예: 01012345678"
              input_defaultValue={number.trim()}
              input_onChange={e => {
                maxLengthCheck(11, e);

                e.target.value != "." && setNumber(e.target.value);
              }}
              button_view={false}
            />
            <Input
              state={"default"}
              title_view={true}
              title="생년월일"
              input_view={true}
              input_type="number"
              input_pattern="\d*"
              input_disable={false}
              input_placeholder="예: 19901023"
              input_defaultValue={birth.trim()}
              input_onChange={e => {
                maxLengthCheck(8, e);
                e.target.value != "." && setBirth(e.target.value);
              }}
              button_view={false}
            />

            <Content>
              <ContentTitle>성별</ContentTitle>
              <div style={{ display: "flex", gap: "8px" }}>
                <ContentRadio
                  active={gender === "1" ? true : false}
                  onClick={() => setGender("1")}>
                  남성
                </ContentRadio>
                <ContentRadio
                  active={gender === "0" ? true : false}
                  onClick={() => setGender("0")}>
                  여성
                </ContentRadio>
              </div>
            </Content>

            <Content>
              <ContentTitle>신분증 정보</ContentTitle>
              <input
                type="file"
                id="fileData"
                accept="image/*"
                capture="camera"
                onChange={e => {
                  encodeFileToBase64(
                    e.target.files, // img or canvas element,
                    setIdCardData
                  );
                }}
                hidden
              />
              {idCardData && idCardData.file != "" && (
                <img
                  id="preview"
                  src={idCardData.file}
                  style={{
                    width: "100%",
                    maxHeight: "400px",
                    borderRadius: "6px",
                  }}
                />
              )}
              {idCardData && idCardData.file != "" ? (
                <div style={{ display: "flex", alignSelf: "flex-end" }}>
                  <LabelButton
                    htmlFor={checkVersion()}
                    severity="light"
                    small={true}
                    disable="on"
                    clickEvent={() => {
                      pageType === "mod" && setFileChange(true);
                      openIdCard();
                    }}>
                    신분증 재등록
                  </LabelButton>
                </div>
              ) : (
                <LabelButton
                  htmlFor={checkVersion()}
                  severity="light"
                  disable="on"
                  L_ICON={IC.etc.ICON_GRAY_PLUS}
                  clickEvent={() => {
                    pageType === "mod" && setFileChange(true);
                    openIdCard();
                  }}>
                  신분증 추가
                </LabelButton>
              )}
            </Content>
          </ContentBody>

          <ContentBody>
            <CommonNoticeText
              title="가족 동의 없이 무단으로 진료를 신청하는 경우 개인정보 보호법 등 법률에 위배될 수 있습니다."
              text=""
              psIcon={true}
            />

            {pageType === "mod" && (
              <Button
                severity="light"
                disable="off"
                padding={true}
                bottomMenu={false}
                clickEvent={() => {
                  setMsgState("check");
                  setViewMsgLayer(true);
                }}>
                프로필 삭제
              </Button>
            )}

            <Button
              severity="primary"
              disable="off"
              padding={true}
              bottomMenu={false}
              clickEvent={() => {
                pageType === "add" ? addFamily() : updateFamily("U", 1);
                // setViewMsgLayer(!viewMsgLayer);
              }}>
              확인
            </Button>
          </ContentBody>
        </ContentsBody>
      </DefaultContainer>

      {viewMsgLayer && (
        <Layer
          headerIcon={messageLayerData[msgState].headerIcon}
          title={messageLayerData[msgState].title}
          desc={messageLayerData[msgState].desc}
          ps={messageLayerData[msgState].ps}
          button={messageLayerData[msgState].button}
        />
      )}
    </Fragment>
  );
};

const ContentsBody = styled.div`
  width: 100vw;
  height: calc(100vh - 57px);
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: 8px;
  background-color: #fafafa;
  /* background-color: black; */
`;

const ContentBody = styled.div`
  flex-grow: 0;
  display: flex;
  /* flex: 1 0 auto; */
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  padding: 40px 20px 24px 20px;
  background-color: #fff;
`;

const Content = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
`;

const ContentTitle = styled.span`
  flex-grow: 1;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #333;
`;

const ContentRadio = styled.div`
  width: 80px;
  height: 40px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 0;
  border-radius: 6px;
  background-color: ${props => (props.active ? "#48454d" : "#f7f7fa")};
  color: ${props => (props.active ? "#fff" : "#888")};
`;

export default Management;
